export interface InviteCallbackPayload {
  accessToken: string | null;
  refreshToken: string | null;
  inviteToken: string | null;
  errorDescription: string | null;
}

function parseCallbackParameters(value: string) {
  return new URLSearchParams(value.startsWith('#') ? value.slice(1) : value);
}

export function parseInviteCallbackUrl(callbackUrl: string): InviteCallbackPayload {
  const parsed = new URL(callbackUrl);
  const searchParams = parseCallbackParameters(parsed.search);
  const hashParams = parseCallbackParameters(parsed.hash);

  const getParam = (key: string) => searchParams.get(key) ?? hashParams.get(key);

  return {
    accessToken: getParam('access_token'),
    refreshToken: getParam('refresh_token'),
    inviteToken: getParam('invite_token'),
    errorDescription: getParam('error_description') ?? getParam('error'),
  };
}

